import { render, staticRenderFns } from "./society.vue?vue&type=template&id=3186515d&"
import script from "./society.vue?vue&type=script&lang=js&"
export * from "./society.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports